
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Cliente } from '@/__env/lib/Clientes';
    import { Wait } from '@/__env/ext';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import { Articulo } from '@/__env/lib/Articulos';
    import { Item } from '@lib/Ventas/Pedidos/Item';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get EdicionPedido() { return this.Controlador.EdicionPedido; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {

            this.Eventos.forEach( x => x() );
        }

        Estado: 'ok' | 'cargando' | 'error' = 'ok';
        @Watch( 'Estado' )
        onEstado()
        {

        }




        async Iniciar()
        {
            this.Estado = 'cargando';

            await Wait( 100 );

            this.Estado = 'ok';
        }


        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }


    }
